import React from 'react';
import type { ContainerProps, GroupBase, MenuProps } from 'react-select';

import {
  Select,
  SelectDisclosureContainer,
  SelectFixedWidthMenu,
  Table as JTTable
} from '@jobandtalent/design-system';
import {
  BaseTableRecord,
  TableProps
} from '@jobandtalent/design-system/dist/components/organisms/Table/Table.types';

import classNames from 'classnames';

import styles from './Table.module.scss';

type AppTableProps = TableProps<BaseTableRecord> & {
  containerClassName?: string;
};

const Table = ({ containerClassName, ...props }: AppTableProps) => {
  return (
    <div className={classNames(styles.container, containerClassName)}>
      <JTTable {...props} />
    </div>
  );
};

type TableFilterProps = {
  className?: string;
  children: React.ReactNode;
};

type ActionOption = {
  value: string;
  label: string;
};

type ActionGroup = GroupBase<ActionOption>;

export const TableFilters = ({ className, children }: TableFilterProps) => (
  <div className={classNames(className, styles.filters)}>{children}</div>
);

// Defined once so re-renders keep the same component types and do not remount the focused input.
const actionsComponents = {
  SelectContainer: (props: ContainerProps<ActionOption, false, ActionGroup>) => (
    <SelectDisclosureContainer {...props} text="Actions" />
  ),
  Menu: (props: MenuProps<ActionOption, false, ActionGroup>) => (
    <SelectFixedWidthMenu {...props} width={200} />
  )
};

export const getActionsRender = (
  onSelectAction: (actionType: string) => void,
  options: { value: string; label: string }[]
) => (
  <Select
    className={styles.actions}
    customComponents={actionsComponents}
    menuPortalTarget={document.body}
    mode="dropdown"
    // react-select blurs on select on touch devices, which would leave nothing for a panel
    // opened from this menu to return focus to. The input is read-only, so no keyboard opens.
    blurInputOnSelect={false}
    styles={{
      menuPortal: (base) => {
        return { ...base, left: 'auto', right: 0, transform: 'translateX(-170px)' }; // width - body padding
      }
    }}
    onChange={(item) => {
      onSelectAction(item?.value ?? '');
    }}
    options={options}
    aria-label="Actions"
  />
);

export default Table;
